import { MarkerIcon, PhoneIcon, TowTruckIcon } from '@rsos/assets/icons';
import { Text } from '@rsos/base-components';
import { UnreadNotificationIcon } from '@rsos/components/capstone/UnreadNotificationIcon/UnreadNotificationIcon';
import type { TowProRequestResponse } from '@rsos/reduxDataStore/src/features/resourceRequests';
import { formatInternationalPhoneNumberHuman } from '@rsos/utils/internationalPhoneNumberUtils';
import { formatDateWithLocalTimezone } from '../../../../../utils/dateUtilities';
import {
  OriginSourcePill,
  OriginSourceTitleRow,
} from '../../../../AirAmbulanceForm/etl/OriginSource.styles';
import styles from '../ResourceRequestPanel/TransportListItem.module.css';
import {
  StyledTransportListItem,
  TransportIconWrapper,
  TransportDetails,
  DetailRow,
} from '../ResourceRequestPanel/TransportListItem.styles';
import {
  formatTowProPickupAddress,
  resolveTowProStatusChip,
} from './towProStatusUtils';

interface TowProListItemProps {
  request: TowProRequestResponse;
  isUnread: boolean;
  onClick: () => void;
}

function TowProListItem({ request, isUnread, onClick }: TowProListItemProps) {
  const pickupAddress = formatTowProPickupAddress(request);
  const statusChip = resolveTowProStatusChip(request);
  const createdAtDisplay = formatDateWithLocalTimezone(
    request.createdAt,
    'HH:mm',
  );

  return (
    <StyledTransportListItem onClick={onClick} data-name="towpro-list-item">
      <TransportIconWrapper>
        <TowTruckIcon color="primaryText" height={20} width={20} />
      </TransportIconWrapper>

      <TransportDetails>
        <OriginSourceTitleRow>
          <Text
            color="primaryText"
            size="large"
            fontWeight="bold"
            lineHeight="1.2"
          >
            Tow
          </Text>
          {createdAtDisplay && (
            <span className={styles.createdAtContainer}>
              <span
                className={styles.timestamp}
                data-testid="towpro-created-at"
              >
                {createdAtDisplay}
              </span>
              {isUnread && (
                <UnreadNotificationIcon
                  data-testid="towpro-list-item-unread-icon"
                  position="center"
                />
              )}
            </span>
          )}
        </OriginSourceTitleRow>

        <div className={styles.statusRow}>
          <span data-testid="towpro-status-chip" className={styles.statusBadge}>
            {statusChip.display}
          </span>
          <OriginSourcePill
            data-testid="towpro-origin"
            className={styles.statusRowSource}
          >
            Unite
          </OriginSourcePill>
        </div>

        {pickupAddress && (
          <DetailRow>
            <MarkerIcon color="secondaryText" height={12} width={12} />
            <Text color="primaryText" size="small">
              {pickupAddress}
            </Text>
          </DetailRow>
        )}

        <DetailRow>
          <PhoneIcon color="secondaryText" height={12} width={12} />
          <Text color="secondaryText" size="small">
            {request.callerId
              ? formatInternationalPhoneNumberHuman(request.callerId)
              : '—'}
          </Text>
        </DetailRow>
      </TransportDetails>
    </StyledTransportListItem>
  );
}

export default TowProListItem;
